import React from 'react';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const ChooseColorLoader = () => {
  return (
    <div style={{ padding: 20 }}>
      <LoadingPlaceholder
        type="textRow"
        ready={false}
        showLoadingAnimation
        color="#E0E0E0"
        style={{ height: '1.3rem', marginTop: '0.6em', marginBottom: '10px', width: '60%' }}
      >
        <span style={{ width: '100%' }} />
      </LoadingPlaceholder>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {Array(40)
          .fill('')
          .map((item, index) => (
            <LoadingPlaceholder
              key={`rect-${index}`}
              type="rect"
              ready={false}
              showLoadingAnimation
              color="#E0E0E0"
              style={{
                height: '250px',
                width: '15%',
                marginRight: '60px',
                marginBottom: '30px',
              }}
            >
              <span style={{ width: '100%' }} />
            </LoadingPlaceholder>
          ))}
      </div>
    </div>
  );
};

export default ChooseColorLoader;
